module.exports = __webpack_public_path__ + "media/kr_web_20w.64e8ebb3.mp4";